import React, { useState, useEffect } from "react";
import { Table, Input, Button } from 'antd';

import MainMenu from 'components/mainMenu';

import requestAPI from 'helpers/requestAPI';
import { toastError, toastSuccess, toastWarning } from 'utils/toastr';

import './index.scss';

const PingPage = () => {
    useEffect(() => {
        refreshTable();
    }, []);

    const [selectedRow, setSelectedRow] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [textareaValue, setTextareaValue] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [inputPlaceHolder, setInputPlaceHolder] = useState('');
    const [activeMode, setActiveMode] = useState('');

    const { TextArea } = Input;
    const columns = [
        {
			title: 'Name',
			dataIndex: 'name',
			key: 'name'
		}
    ];

    const rowSelection = {
        selectedRowKeys: selectedRow,
        columnWidth: '0px',
		onChange: (selectedRowKeys) => {
			setSelectedRow(selectedRowKeys);
		}
    };

    const refreshTable = () => {
        const params = {
			routeParams: {
				route: 'manage_ping'
            }
        };

        setLoading(true);

        requestAPI(params).then((response) => {
            const data = response.data.data.map((elem, index) => {
                return {
                    key: elem.id,
                    name: elem.name
                }
            });
            setTableData(data);
        }).catch(err => console.log(err));

        setLoading(false);
    };
    
    const onRowClick = (record) => {
        if(record.key === selectedRow[0]) return;
        if(activeMode) return;
        setSelectedRow([record.key]);
        const params = {
			routeParams: {
				route: 'manage_ping/' + record.key
            }
        };

        requestAPI(params).then(response => {
            setTextareaValue(response.data.data.site)
        })
    };

    const onInputChange = (e) => {
        setInputValue(e.target.value);
    }

    const onCreateBtnClick = () => {
        setActiveMode('create');
        setInputPlaceHolder('Enter name');
        setTextareaValue('');
    };

    const onSaveBtnClick = () => {
        if(!inputValue.trim().length || !textareaValue.trim().length) {
            toastWarning('Please fill all fields!');
            return;
        }

        if(activeMode === "create") {
            const createParams = {
                routeParams: {
                    route: 'manage_ping'
                },
                method: 'POST',
                data: {
                    name: inputValue,
                    site: textareaValue
                }
            };

            requestAPI(createParams).then(() => {
                toastSuccess('Record created!');
                refreshTable();
                setActiveMode('');
                setSelectedRow([]);
                setInputPlaceHolder('');
            }).catch(err => toastError(err));

            return;
        };

        if(activeMode === "change") {
            const changeParam = {
                routeParams: {
                    route: 'manage_ping/' + selectedRow[0] 
                },
                method: 'PUT',
                data: {
                    name: inputValue,
                    site: textareaValue
                }
            };

            requestAPI(changeParam).then(() => {
                toastSuccess('Record changed!');
                refreshTable();
                setActiveMode('');
                setSelectedRow([]);
                setInputPlaceHolder('');
            });

            return;
        }
    }

    const onChangeBtnClick = () => {
        if(!selectedRow.length) return toastWarning('Please select some record');
        setActiveMode('change');
        setInputPlaceHolder('Enter new name');
    }

    const onCancelBtnClick = () => {
        setActiveMode('');
        setTextareaValue('');
        setInputValue('');
        setInputPlaceHolder('');
        setSelectedRow([]);
    };

    const onDeleteBtnClick = () => {
        if(!selectedRow.length) return toastWarning('Please select some record');
        const deleteParam = {
            routeParams: {
                route: 'manage_ping/' + selectedRow[0]
            },
            method: 'DELETE'
        };

        requestAPI(deleteParam).then(() => {
            toastSuccess('Record has been deleted!');
            refreshTable();
            setTextareaValue('');
            setSelectedRow([]);
        }).catch(err => toastError(err));
    };

    const onTextareaChange = (e) => {
        setTextareaValue(e.target.value);
    }

    return (
        <div className="ping-wrapper">
            <MainMenu />
            <div className="ping__functional-area">
                <div className="ping__functional-area__left">
                    <div className="ping__functional-area__left-top">
                        <Table
                            className="ping__functional-area__name-table"
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={tableData}
                            pagination={true}
                            hideDefaultSelections={true}
                            size={'small'}
                            loading={loading}
                            scroll={{ y: '264px' }}
                            onRow={(record) => ({
                                onClick: () => {
                                    onRowClick(record);
                                }
                            })}
                        />
                    </div>
                    <div className="ping__functional-area__left-bottom">
                        <Input 
                            placeholder={inputPlaceHolder}
                            onChange={onInputChange} 
                            value={inputValue}
                            disabled={!activeMode}
                            className="ping__functional-area__input" 
                        />
                        <div className="ping__functional-area__buttons-row">
                            <Button disabled={activeMode} type="primary" onClick={onCreateBtnClick}>Create</Button>
                            <Button disabled={activeMode} type="primary" onClick={onChangeBtnClick} className="ping__functional-area__buttons-row__change-btn">Change</Button>
                            <Button disabled={activeMode} onClick={onDeleteBtnClick} type="danger">Delete</Button>
                        </div>
                        <div className="ping__functional-area__buttons-row">
                            <Button onClick={onSaveBtnClick} type="default" disabled={!activeMode}>Save</Button>
                            <Button onClick={onCancelBtnClick} type="danger" disabled={!activeMode} ghost>Cancel</Button>
                        </div>
                    </div>
                </div>
                <div className="ping__functional-area__right">
                    <TextArea 
                        disabled={!activeMode} 
                        className="ping__functional-area__textarea" 
                        value={textareaValue}
                        onChange={onTextareaChange}
                    />
                </div>
            </div>
        </div>
    )
};

export default PingPage;